import { jsx as _jsx } from "react/jsx-runtime";
import { LAYER_TYPE } from '@tmapy/config';
import { TileLayer } from './layers/TileLayer';
import { VectorLayer } from './layers/VectorLayer';
import { WMTSLayer } from './layers/WMTSLayer';
import { TileArcGISLayer } from './layers/TileArcGISLayer';
import { TileArcGISRestLayer } from './layers/TileArcGISRestLayer';
import { ImageArcGISRestLayer } from './layers/ImageArcGISRestLayer';
import { ImageWMSLayer } from './layers/ImageWMSLayer';
import { VectorTileLayer } from './layers/VectorTileLayer';
import { FeatureArcGISLayer } from './layers/FeatureArcGISLayer';
export const Layer = (props) => {
    switch (props.type) {
        case LAYER_TYPE.TILE: {
            return _jsx(TileLayer, { ...props });
        }
        case LAYER_TYPE.VECTOR: {
            return _jsx(VectorLayer, { ...props });
        }
        case LAYER_TYPE.WMTS: {
            return _jsx(WMTSLayer, { ...props });
        }
        case LAYER_TYPE.TILE_ARCGIS: {
            return _jsx(TileArcGISLayer, { ...props });
        }
        case LAYER_TYPE.TILE_ARCGIS_REST: {
            return _jsx(TileArcGISRestLayer, { ...props });
        }
        case LAYER_TYPE.IMAGE_ARCGIS_REST: {
            return _jsx(ImageArcGISRestLayer, { ...props });
        }
        case LAYER_TYPE.IMAGE_WMS: {
            return _jsx(ImageWMSLayer, { ...props });
        }
        case LAYER_TYPE.TILE_VECTOR: {
            return _jsx(VectorTileLayer, { ...props });
        }
        case LAYER_TYPE.FEATURE_ARCGIS: {
            return _jsx(FeatureArcGISLayer, { ...props });
        }
        default:
            return null;
    }
};
//# sourceMappingURL=Layer.js.map